import { useEffect, useRef, useState, type ReactNode } from "react";
import { Maximize, Minimize } from "lucide-react";
import { ToolDialog } from "../../../packages/test-ui/tool-dialog";

export function ReviewPresentation({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLElement>(null);
  const button = useRef<HTMLButtonElement>(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  useEffect(() => {
    const change = () => {
      const active = document.fullscreenElement === ref.current;
      setFullscreen(active);
      if (!active) button.current?.focus();
    };
    document.addEventListener("fullscreenchange", change);
    return () => document.removeEventListener("fullscreenchange", change);
  }, []);
  const enter = async () => {
    try {
      if (!ref.current?.requestFullscreen) { setExpanded(true); return; }
      await ref.current.requestFullscreen();
    } catch { setExpanded(true); }
  };
  const content = <div className="review-presentation-content">{children}</div>;
  return <section ref={ref} className="result-review question-review" onKeyDown={event => {
    if (event.key === "Escape" && fullscreen && !(event.target instanceof HTMLElement && event.target.closest("dialog[open]"))) {
      event.preventDefault(); void document.exitFullscreen();
    }
  }}>
    <header className="review-presentation-heading"><h2>Question review</h2><button ref={button} type="button" className="secondary-button" onClick={() => { if (fullscreen) void document.exitFullscreen(); else void enter(); }}>
      {fullscreen ? <Minimize size={16} /> : <Maximize size={16} />}{fullscreen ? "Exit full screen" : "Full screen"}
    </button></header>
    {expanded ? <ToolDialog title="Question review · Full screen" className="review-presentation-dialog" onClose={() => setExpanded(false)}>{content}</ToolDialog> : content}
  </section>;
}
